import { render, staticRenderFns } from "./EditPassword2.vue?vue&type=template&id=35e715de&scoped=true&"
import script from "./EditPassword2.vue?vue&type=script&lang=js&"
export * from "./EditPassword2.vue?vue&type=script&lang=js&"
import style0 from "./EditPassword2.vue?vue&type=style&index=0&id=35e715de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e715de",
  null
  
)

export default component.exports